"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExpenseCategoryParsedResponse = exports.transformExpenseCategoryListResponse = exports.transformExpenseCategoryResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
const Error_1 = require("./Error");
function transformExpenseCategoryResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { category } = response.response.result;
    return transformExpenseCategoryParsedResponse(category);
}
exports.transformExpenseCategoryResponse = transformExpenseCategoryResponse;
function transformExpenseCategoryListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { categories, page, pages, per_page, total } = response.response.result;
    return {
        categories: categories.map((category) => transformExpenseCategoryParsedResponse(category)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformExpenseCategoryListResponse = transformExpenseCategoryListResponse;
function transformExpenseCategoryParsedResponse(category) {
    return {
        category: category.category,
        categoryId: category.categoryid,
        createdAt: category.created_at && (0, Date_1.transformDateResponse)(category.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        id: category.id,
        isCogs: category.is_cogs,
        isEditable: category.is_editable,
        parentId: category.parentid,
        transactionPosted: category.transaction_posted,
        updatedAt: category.updated_at && (0, Date_1.transformDateResponse)(category.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        visState: category.vis_state,
    };
}
exports.transformExpenseCategoryParsedResponse = transformExpenseCategoryParsedResponse;
//# sourceMappingURL=ExpenseCategory.js.map